//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Euro',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
        item3: '0',
        item4: '0',
        item5: '0',
        item6: '0',
        item7: '0',
        item8: '0',
        item9: '0',
        item10: '0',
        item11: '',
        item12: '0',
        item13: '0',
        item14: '0',
        item15: '0',
        item16: '0',
        item17: '0',
      },
      item1List: [
        { value: '0', name: '<60岁' },
        { value: '1', name: '60~64岁' },
        { value: '2', name: '65~69岁' },
        { value: '3', name: '70~74岁' },
        { value: '4', name: '75~89岁' },
        { value: '5', name: '≥90岁' },
      ],
      item2List: [
        { value: '0', name: '男性' },
        { value: '1', name: '女性' },
      ],
      item11List: [
        { value: '0', name: 'LVEF＞50%' },
        { value: '1', name: '中度或LVEF30-50%' },
        { value: '3', name: 'LVEF＜30%' },
      ],
      hasScore: false,
      disabled: false,
      descTxt: '',
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.item1 * 1 + form.item2 * 1 + form.item3 + form.item4 * 2 + form.item5 * 2 + form.item6 * 3 + form.item7 * 2 + form.item8 * 3 + form.item9 * 3 + form.item10 * 2 + form.item11 * 1 + form.item12 * 2 + form.item13 * 2 + form.item14 * 2 + form.item15 * 2 + form.item16 * 3 + form.item17 * 4
      self.hasScore = true
      if (result < 3) {
        self.descTxt = '低风险'
      } else if (result < 6) {
        self.descTxt = '中风险'
      } else {
        self.descTxt = '高风险'
      }
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Euro.vue